import React from "react";
import {
  IconBook,
  IconHelp,
  IconBug,
  IconDoc,
  IconInfo,
  IconClose,
} from "./CricketIcons";

interface Props {
  onClose: () => void;
  onRules: () => void;
  onSupport: () => void;
  onReportIssue: () => void;
  onTerms: () => void;
  onAbout: () => void;
}

export default function MoreMenu({ onClose, onRules, onSupport, onReportIssue, onTerms, onAbout }: Props) {
  const handle = (action: () => void) => {
    onClose();
    action();
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-[9998]" onClick={onClose}>
      <div
        className="fixed right-0 top-0 h-full w-72 overflow-y-auto z-[9999] shadow-2xl"
        style={{
          background: "linear-gradient(180deg, #0a0f0d 0%, #0d1512 100%)",
          borderLeft: "1px solid rgba(255,255,255,0.08)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-5 py-4 flex items-center justify-between" style={{ borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
          <h2 className="text-lg font-bold text-white tracking-tight">More</h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-slate-400 hover:text-white hover:bg-white/5 transition-colors"
            aria-label="Close"
          >
            <IconClose className="w-5 h-5" />
          </button>
        </div>

        <nav className="p-3">
          <SectionLabel>Tools &amp; Resources</SectionLabel>
          <MenuButton icon={<IconBook className="w-5 h-5" />} label="Rules of Cricket" onClick={() => handle(onRules)} />
          <MenuButton icon={<IconHelp className="w-5 h-5" />} label="Help & Support" onClick={() => handle(onSupport)} />
          <MenuButton icon={<IconBug className="w-5 h-5" />} label="Report an Issue" onClick={() => handle(onReportIssue)} />

          <SectionLabel>Legal &amp; Information</SectionLabel>
          <MenuButton icon={<IconDoc className="w-5 h-5" />} label="Terms & Conditions" onClick={() => handle(onTerms)} />
          <MenuButton icon={<IconInfo className="w-5 h-5" />} label="About WatchWicket" onClick={() => handle(onAbout)} />
        </nav>
      </div>
    </div>
  );
}

function SectionLabel({ children }: { children: React.ReactNode }) {
  return (
    <div className="px-4 pt-4 pb-1.5">
      <span className="text-[11px] font-bold uppercase tracking-wider text-slate-500">{children}</span>
    </div>
  );
}

function MenuButton({
  icon,
  label,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium text-white transition-colors duration-150 hover:bg-white/5"
    >
      <span className="text-slate-300">{icon}</span>
      <span>{label}</span>
    </button>
  );
}
